export const visit = (vm, at) => {
at({ "de": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} von {{totalBytes}}" }, "fileSizeLimit": "Die Datei darf nicht gr\xF6\xDFer als {{size}} sein.", "screenCapture": "Bildschirmaufnahme" } } });
};